const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/ai/$conversationId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/ai/$conversationId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    shellMode: "canvas-only"
  }
});